/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import address from 'forms/shared/validators/models/location/models/address';
import { DEFAULT_LATEST } from 'constants/dateLimits';
import { ValidateJSModel } from 'forms/shared/types/validatejs';
import { isPVQForm } from 'helpers/form';
import pvqLocationModelValidator from 'forms/shared/validators/models/location/pvqLocation';
import { systemITLocationOptions, handlingProtectedInformationDisciplinaryOptions } from 'constants/enums/informationTechnologyOptions';
import { hasYesOrNo } from 'models/validate';
import { REQUIRED } from 'constants/errors';
import { isSafeUnitedStates } from 'helpers/locations';
import { LegalTechnologyProtectedUnauthorizedItemModel } from '../types';

export const legalTechnologyProtectedUnauthorizedItemValidator: ValidateJSModel<LegalTechnologyProtectedUnauthorizedItemModel> = {
  // PVQ Only fields below
  Date: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      const { applicantBirthdate } = options;

      return {
        presence: true,
        date: { earliest: applicantBirthdate, latest: DEFAULT_LATEST },
      };
    }
    return {};
  },
  Incident: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType) && attributes?.ProtectedInformationAccessLocation?.values?.includes('Other')) {
      return { presence: true, hasValue: true };
    }
    return {};
  },
  Location: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return {
        location: {
          requireIsMilitaryDiplomaticAddress: true,
          requireMilitaryDiplomaticInstallationName: true,
          requireStreet: isSafeUnitedStates(value),
          requireApoFpoDpoPostcode: !isSafeUnitedStates(value),
          validator: pvqLocationModelValidator,
        },
        presence: true,
      };
    }
    return {};
  },
  Action: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType) && attributes?.AccessAttemptOutcome?.value === 'Yes') {
      return { presence: true, hasValue: true };
    }
    return {};
  },
  ProtectedInformationAccessLocation: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return {
        array: {
          length: {
            message: REQUIRED,
            minimum: 1,
          },
          validator: {
            inclusion: systemITLocationOptions,
            presence: true,
          }
        },
        presence: true,
      };
    }
    return {};
  },
  AccessAttemptOutcome: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return { presence: true, hasValue: { validator: hasYesOrNo } };
    }
    return {};
  },
  AccessAttemptReason: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return { presence: true, hasValue: true };
    }
    return {};
  },
  AccessAttemptDisciplinaryAction: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return {
        array: {
          length: {
            message: REQUIRED,
            minimum: 1,
          },
          validator: {
            inclusion: handlingProtectedInformationDisciplinaryOptions,
            presence: true,
          }
        },
        presence: true,
      };
    }
    return {};
  },
  DisciplinaryActionExplanation: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return { presence: true, hasValue: true };
    }
    return {};
  },
  DisciplinaryActionOtherExplanation: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType) && attributes?.AccessAttemptDisciplinaryAction?.values?.includes('Other')) {
      return { presence: true, hasValue: true };
    }
    return {};
  },
};
